import { Container, Stack } from '@mui/material';

export default function TableButtonsContainer({ children, maxWidth = "none" }) {
  return (
    <Container sx={{ mb: 1 }} maxWidth={maxWidth}>
      <Stack direction="row" spacing={2}>
        {children}
      </Stack>
    </Container>
  );
}
